import { z } from 'zod';
import { BLOG_ANSWER_KEYS } from '@hrlabs/shared-types';
import { zTranslatable, zTranslatableBgRequired } from './translatable.js';
const MAX_THUMB_KB = 8096;
const answersShape = Object.fromEntries(BLOG_ANSWER_KEYS.map((k) => [k, zTranslatable.optional()]));
/** Admin "save blog post" payload. Mirrors Admin\BlogController::save(). */
export const blogPostSaveSchema = z.object({
    title: zTranslatableBgRequired,
    subtitle: zTranslatable.nullable().optional(),
    description: zTranslatableBgRequired,
    status: z.enum(['draft', 'published']),
    /** Storage path once uploaded; null keeps the existing thumbnail. */
    thumbnailPath: z.string().nullable().optional(),
    ...answersShape,
});
/** Client-side guard for a picked thumbnail file (size in KB). */
export const blogThumbnailFileSchema = z.object({
    sizeKb: z.number().max(MAX_THUMB_KB, `Thumbnail must be <= ${MAX_THUMB_KB} KB`),
    type: z.enum(['image/jpeg', 'image/png', 'image/jpg', 'image/gif']),
});
/** Input to the translateBlogPost Cloud Function: Bulgarian source fields. */
export const translateBlogPostInputSchema = z
    .object({
    description_bg: z.string().min(1),
})
    .catchall(z.string().optional());
//# sourceMappingURL=blogPost.js.map